/**
 * Google Tag Manager Service
 * Zentrale Verwaltung aller GTM-Events
 */

class GTMService {
  constructor() {
    // Stelle sicher, dass dataLayer existiert
    window.dataLayer = window.dataLayer || [];
  }

  /**
   * Prüft, ob GTM-Consent vorhanden ist
   */
  hasConsent() {
    const consent = localStorage.getItem('cookieConsent');
    if (consent) {
      try {
        const parsed = JSON.parse(consent);
        return parsed.googleTagManager === true;
      } catch (e) {
        return false;
      }
    }
    return false;
  }

  /**
   * Sendet ein Event an den dataLayer
   * @param {string} eventName - Name des Events
   * @param {object} eventData - Zusätzliche Event-Daten
   */
  pushEvent(eventName, eventData = {}) {
    if (!this.hasConsent()) {
      console.log('GTM Event blocked - no consent:', eventName);
      return;
    }

    const event = {
      event: eventName,
      ...eventData
    };

    window.dataLayer.push(event);
    console.log('GTM Event pushed:', event);
  }

  /**
   * Sendet ein Page View Event
   * @param {string} pagePath - Der Pfad der Seite
   * @param {string} pageTitle - Der Titel der Seite
   */
  trackPageView(pagePath, pageTitle) {
    this.pushEvent('page_view', {
      page_path: pagePath,
      page_title: pageTitle || document.title,
      page_location: window.location.href
    });
  }

  /**
   * Trackt einen Button-Klick
   * @param {string} buttonName - Name/ID des Buttons
   * @param {string} category - Kategorie (z.B. 'Navigation', 'Form', etc.)
   */
  trackButtonClick(buttonName, category = 'general') {
    this.pushEvent('button_click', {
      button_name: buttonName,
      button_category: category
    });
  }

  /**
   * Trackt ein Formular-Submit
   * @param {string} formName - Name des Formulars
   * @param {object} formData - Optionale Formulardaten (ohne sensible Daten!)
   */
  trackFormSubmit(formName, formData = {}) {
    this.pushEvent('form_submit', {
      form_name: formName,
      ...formData
    });
  }

  /**
   * Trackt eine Produkt-Ansicht (für Stapler)
   * @param {object} productData - Produktdaten
   */
  trackProductView(productData) {
    this.pushEvent('view_item', {
      currency: 'EUR',
      value: productData.price || 0,
      items: [{
        item_id: productData.id,
        item_name: productData.name,
        item_category: productData.category || 'Stapler',
        item_brand: productData.brand || '',
        price: productData.price || 0,
        quantity: 1
      }]
    });
  }

  /**
   * Trackt eine Kontaktanfrage
   * @param {string} contactType - Art der Anfrage (z.B. 'email', 'phone', 'form')
   * @param {object} details - Zusätzliche Details
   */
  trackContactRequest(contactType, details = {}) {
    this.pushEvent('generate_lead', {
      contact_type: contactType,
      ...details
    });
  }

  /**
   * Trackt einen Download
   * @param {string} fileName - Name der Datei
   * @param {string} fileType - Typ der Datei (z.B. 'pdf', 'doc')
   */
  trackDownload(fileName, fileType) {
    this.pushEvent('file_download', {
      file_name: fileName,
      file_extension: fileType
    });
  }
}

// Singleton-Instanz exportieren
export default new GTMService();